module.exports = __webpack_public_path__ + "img/nature-35.0c4a78ae.jpg";